import { render, staticRenderFns } from "./SignUpForm.vue?vue&type=template&id=ab4917fe&scoped=true"
import script from "./SignUpForm.vue?vue&type=script&lang=ts"
export * from "./SignUpForm.vue?vue&type=script&lang=ts"
import style0 from "./SignUpForm.vue?vue&type=style&index=0&id=ab4917fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4917fe",
  null
  
)

export default component.exports